import { render as renderConfig } from './render.js';

const store = new Map();

/**
 * Minimal named ElementConfig registry.
 */
export const registry = {
  /**
   * @param {string} name
   * @param {object} config
   */
  define(name, config) {
    if (!name) throw new Error('[ElementBuilder.registry] name is required');
    store.set(String(name), config);
    return registry;
  },

  /**
   * @param {string} name
   * @returns {object|undefined}
   */
  get(name) {
    return store.get(String(name));
  },

  /**
   * @param {string} name
   * @returns {boolean}
   */
  has(name) {
    return store.has(String(name));
  },

  /**
   * @param {string} name
   * @param {object} [ctx]
   * @returns {string}
   */
  render(name, ctx) {
    const cfg = store.get(String(name));
    if (!cfg) {
      console.warn(`[ElementBuilder.registry] Unknown config "${name}".`);
      return '';
    }
    return renderConfig(cfg, ctx);
  },

  clear() {
    store.clear();
  },

  keys() {
    return [...store.keys()];
  }
};
